import React, {useContext} from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { CSVLink } from "react-csv";
import { coreAxios } from "utilities/axios";
import AuthContext from  "../context/AuthContext";

const BASE_URL = process.env.REACT_APP_MAIN_URL


export const CustomStockToolbar = ({
    selectedData,
    exportBtn = false,
    fileName,
    setShowCreateModal,
    expandAll,
    collapseAll,
    hideLeftToolbar,
    ...rest
}) => {

    const route = window.location.href.split("/").pop();
    const date = new Date().toISOString();
    const { user } = useContext(AuthContext);


    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button 
                        label="All Barcode Download" 
                        icon="pi pi-download" 
                        className="p-button-success mr-2" 
                        onClick={() => {
                            downloadBarcode()
                        }}
                    />
                    {/* <Button 
                        label="Selected Barcode Download" 
                        icon="pi pi-download" 
                        className="p-button-success mr-2" 
                        onClick={() => {
                            downloadSelectedBarcode(selectedData)
                        }}
                    /> */}
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            
            <React.Fragment>
                {
                    expandAll && (
                        <Button icon="pi pi-plus" label="Expand All" onClick={expandAll} text />
                    )
                }
                                {
                    collapseAll && (
                        <Button icon="pi pi-minus" label="Collapse All" onClick={collapseAll} text />
                    )
                }
                {
                    exportBtn && (
                    <CSVLink asyncOnClick={true} data={selectedData} filename={`${fileName || route} report-${date.split("T")[0]}`}>
                        <Button label="Export" icon="pi pi-download" className="p-button-help" />
                    </CSVLink>
                    )
                }
            </React.Fragment>
        );
    };

    const downloadBarcode = async () => {

        const url = `${BASE_URL}/api/all/stock/barcode/download/`;
        try {
            const response = await coreAxios.get(url, {
                responseType: 'blob',
            });
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `barcode.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch(error){
            console.log(error)
        }
    }

    const downloadSelectedBarcode = async (data) => {
        console.log("data: ", data)
        const modifiedData = {
            id: data.map((value) => {
                return value.id
                
            })
        };
        console.log("modified: ", modifiedData)

        const url = `${BASE_URL}/api/selected/stock/barcode/download/`;
        try {
            const response = await coreAxios.post(url,modifiedData);
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `barcode.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch(error){
            console.log(error)
        }
    }


    return (
        <>
        {
            hideLeftToolbar ? <Toolbar className="mb-4" right={rightToolbarTemplate}/> : 
            <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}/>
        }
        </>
    );
};